import { isJson, TrackingIdentifier } from '@ael/core-api';
import { Map, Set } from 'immutable';
import {
  PreviouslySelectedOptionsForItems,
  PreviouslySelectedOptionsForWidgets
} from '../../../../reducers/student/tracking/questionWidgetTrackingReducer';
import {PersistenceTrackingData, TrackingDataVersion} from '../trackingClient';

interface CompressedTrackingData {
  v: number;
  d: TrackingIdentifier[];
  w: PreviouslySelectedOptionsForItems;
}
// TODO: Maybe get rid of this???
const reduceParsedDataOfItems = (parsedDataOfItems: PreviouslySelectedOptionsForItems) => {
  return parsedDataOfItems.reduce(
    (
      acc: PreviouslySelectedOptionsForItems,
      widgetIdSelectedOptionObject: PreviouslySelectedOptionsForWidgets,
      itemId: TrackingIdentifier
    ) => {
      const widgetIdSelectedOptionsMap = Map(widgetIdSelectedOptionObject);
      return acc.set(itemId, widgetIdSelectedOptionsMap);
    },
    Map<TrackingIdentifier, PreviouslySelectedOptionsForWidgets>()
  );
};

const deserializeWidgetData = (widgetData: string | undefined): PreviouslySelectedOptionsForItems => {
  if (widgetData === undefined) {
    return Map<TrackingIdentifier, PreviouslySelectedOptionsForWidgets>();
  }
  const parsedDataOfItems: PreviouslySelectedOptionsForItems = Map(JSON.parse(widgetData));
  const parsedDataOfItemsAndWidgets = reduceParsedDataOfItems(parsedDataOfItems);
  return parsedDataOfItemsAndWidgets;
};

export interface Serializer {
  serializeData: (finishedItems: Set<TrackingIdentifier>, widgetTracking: PreviouslySelectedOptionsForItems) => string;
  deserializeData: (serialized: string) => PersistenceTrackingData;
}

/*
Serializes and deserializes tracking data
 */
const sectionsSplitChar = '|';
const createSerializer = (separator: string): Serializer => ({
  serializeData: (
    finishedItems: Set<TrackingIdentifier>,
    widgetTracking: PreviouslySelectedOptionsForItems
  ): string => {
    const serializedTrackingData: CompressedTrackingData = {
      v: TrackingDataVersion.v2,
      d: finishedItems.toArray(),
      w: widgetTracking, // TODO
    };

    return JSON.stringify(serializedTrackingData);
  },
  deserializeData: (serialized: string): PersistenceTrackingData => {
    // TrackingData V2 or newer - no need to check for version, because if it's json, we know it's V2 or newer
    if (isJson(serialized)) {
      const trackingData = JSON.parse(serialized) as CompressedTrackingData;

      const deserializedFinishedData: Set<TrackingIdentifier> = Set(trackingData.d);
      const deserializedWidgetData = deserializeWidgetData(JSON.stringify(trackingData.w));

      return {
        version: TrackingDataVersion.v2,
        finishedItems: deserializedFinishedData,
        widgetTrackingData: deserializedWidgetData,
      };
    }
    //  LEGACY code V1 - use the old alghoritmus for deserializing data
    const [itemData, widgetData] = serialized.split(sectionsSplitChar);

    const deserializedItemData =
      itemData === ''
        ? Set<TrackingIdentifier>()
        : Set<TrackingIdentifier>(itemData.split(separator) as TrackingIdentifier[]);
    const deserializedWidgetTrackingData = deserializeWidgetData(widgetData);

    return {
      finishedItems: deserializedItemData,
      widgetTrackingData: deserializedWidgetTrackingData,
      version: TrackingDataVersion.v1,
    };
  },
});

/*
Serializer for SCORM data where I for some reason decided that comma is best separator
 */
export const CommaSerializer = createSerializer(',');
/*
Serializer for online/offline data where I for some reason decided that semicolon is best separator
Online and offline have to have same serializer, otherwise upload of offline data, once user goes online
won't work
 */
export const SemicolonSerializer = createSerializer(';');
